<template>
  <!-- 组件主盒子 -->
  <div>
    <div class="query-select">
      <el-form :inline="true" :model="queryForm" class="user-search">
        <el-form-item label="试卷名称：">
          <el-input
            size="small"
            v-model="queryForm.name"
            placeholder="输入名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="等级：">
          <el-select
            size="small"
            @change="getTableInfo"
            clearable
            v-model="queryForm.courseLevel"
            placeholder="请选择难度等级"
          >
            <el-option label="全部" value=""></el-option>
            <el-option
              v-for="item in examLevel"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="创建日期：" class="mr-left">
          <el-date-picker
            @change="dateChange"
            size="small"
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </el-form>
      <div class="div_select_button">
        <el-button
          type="primary"
          icon="el-icon-search"
          plain
          size="small"
          round
          @click="getTableInfo"
          >查询</el-button
        >
        <el-button
          type="warning"
          icon="el-icon-refresh-left"
          plain
          size="small"
          round
          @click="resetSelect"
          >重置</el-button
        >
        <el-button
          type="success"
          icon="el-icon-plus"
          plain
          size="small"
          round
          @click="addNewData"
          >新增</el-button
        >
      </div>
    </div>
    <div class="main-table">
      <el-table
        :data="tableData"
        style="width: 85vw"
        border
        size="small"
        stripe
        v-loading="loading"
        header-cell-class-name="table-header"
      >
        <el-table-column align="center" type="index" width="50">
        </el-table-column>
        <el-table-column align="center" prop="name" label="试卷名称">
        </el-table-column>
        <el-table-column align="center" prop="courseLevel" label="等级">
          <template slot-scope="scope">
            {{ getExamLabel(scope.row.courseLevel) }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="score" label="试卷分数">
          <template slot-scope="scope">
            {{ scope.row.score || 0 }}
          </template>
        </el-table-column>
        <el-table-column align="center" prop="createTime" label="创建日期">
        </el-table-column>
        <el-table-column align="center" prop="publish" label="上架状态">
          <template slot-scope="scope">
            <el-switch
              @change="publishChange(scope.row)"
              v-model="scope.row.publish"
              :active-value="1"
              :inactive-value="0"
            >
            </el-switch>
          </template>
        </el-table-column>

        <el-table-column align="center" label="操作" width="400">
          <template slot-scope="scope">
            <el-button
              plain
              size="mini"
              round
              type="primary"
              @click="handleClick(scope.row)"
              >查看</el-button
            >
            <el-button
              plain
              size="mini"
              round
              type="warning"
              @click="editClick(scope.row)"
              >编辑</el-button
            >
            <el-button
              type="danger"
              plain
              size="mini"
              round
              @click="removeClick(scope.row.questionPaperId)"
              >删除</el-button
            >
            <el-button
              plain
              size="mini"
              round
              @click="contact(scope.row)"
              v-if="scope.row.isGeneratePaper != 1"
              >关联试题</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @current-change="handleCurrentChange"
        :current-page.sync="queryForm.pageNum"
        :page-size="queryForm.pageSize"
        layout="total, prev, pager, next"
        :total="totalCount"
      >
      </el-pagination>
    </div>
    <!-- 试卷弹框 -->
    <PaperDialog ref="paperDialogRef" @success="getTableInfo" />
    <!-- 关联试题弹框 -->
    <QuestionDialog
      ref="questionDialogRef"
      @success="getTableInfo"
      @bucketOpen="openBucket"
    />
    <!-- 试题篮 -->
    <BucketDialog
      ref="bucketDialogRef"
      @success="bucketSave"
      @clearBucket="clearBucket"
      @openScore="openScore"
    />
    <ScoreDialog
      ref="scoreDialogRef"
      @success="getTableInfo"
      @setScore="setScore"
    />
  </div>
</template>
<script>
import {
  getPaperTable,
  savePaper,
  lookPaperInfo,
  editPaper,
  removePaper
} from "@/api/manage";
import PaperDialog from "./PaperDialog";
import QuestionDialog from "./QuestionDialog";
import BucketDialog from "./BucketDialog";
import ScoreDialog from "./ScoreDialog.vue";
import { tansParams } from "@/utils/util";
import { handsOnQuestionTypes, examLevel, getExamLabel } from "@/utils/dict.js";
export default {
  name: "welcome",
  components: {
    PaperDialog,
    QuestionDialog,
    BucketDialog,
    ScoreDialog
  },
  data() {
    return {
      examLevel,
      loading: false, //是显示加载
      queryForm: {
        name: "",
        pageNum: 1,
        pageSize: 10
      },
      dateRange: [],
      tableData: [],
      totalCount: 0
    };
  },
  // 挂载结束状态(里面是操作)
  mounted() {
    this.getTableInfo();
  },

  methods: {
    getExamLabel,
    dateChange(val) {
      this.queryForm.params = { beginTime: val[0], endTime: val[1] };
      this.getTableInfo();
    },
    openScore(paper, data) {
      this.$refs.scoreDialogRef.open(paper, data);
    },
    resetSelect() {
      this.queryForm = {
        name: "",
        pageNum: 1,
        pageSize: 10
      };
      this.dateRange = null;
      this.getTableInfo();
    },
    // 试题保存回调
    bucketSave() {
      this.$refs.questionDialogRef.close();
      this.getTableInfo();
    },
    // 清空试题
    clearBucket() {
      this.$refs.questionDialogRef.setBucket([]);
    },
    setScore(data) {
      this.$refs.bucketDialogRef.setScore(data);
      this.$refs.questionDialogRef.setBucket(
        Object.values(data).flatMap(item => item.data)
      );
    },
    async publishChange(row) {
      if (row.score == 0) {
        this.$message({
          type: "warn",
          message: "试卷分数为0，无法发布"
        });
        row.publish = row.publish == 1 ? 0 : 1;
        return;
      }
      const text = row.publish == 1 ? "发布" : "下架";
      await this.$confirm(`确定${text}此试卷?`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const params = {
            questionPaperId: row.questionPaperId,
            publish: row.publish
          };
          const res = await editPaper(params);
          if (res.data.code === 200) {
            this.$message({
              type: "success",
              message: `${text}成功!`
            });
            this.resetSelect();
          } else {
            this.$message({
              type: "warn",
              message: `${text}失败!`
            });
            this.resetSelect();
          }
        })
        .catch(() => {
          row.publish = row.publish == 1 ? 0 : 1;
        });
    },

    async removeClick(id) {
      this.$confirm("此操作将永久删除该内容, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          const res = await removePaper(id);

          if (res.data.code === 200) {
            this.$message({
              type: "success",
              message: "删除成功!"
            });
            this.resetSelect();
          }
        })
        .catch(() => {});
    },

    // 列表查询
    async getTableInfo() {
      this.loading = true;
      let params = this.queryForm;

      const res = await getPaperTable(tansParams(params));
      this.loading = false;

      if (res.data.code === 200) {
        this.tableData = res.data.data.rows;
        this.totalCount = res.data.data.total;
      }
    },
    // 翻页
    handleCurrentChange(val) {
      this.queryForm.pageNum = val;
      this.getTableInfo();
    },
    // 查看试题
    async handleClick(item) {
      this.$refs.bucketDialogRef.open(false, item);
    },
    // 打开试题篮
    openBucket(row, data) {
      this.$refs.bucketDialogRef.open(true, row, data);
    },
    // 关联试题
    async contact(val) {
      this.$refs.questionDialogRef.open(val);
    },
    // 新增试卷
    addNewData() {
      this.$refs.paperDialogRef.open("add");
    },
    // 编辑试卷
    editClick(item) {
      this.$refs.paperDialogRef.open("edit", item);
    }
  }
};
</script>
<style lang="less" scoped>
.dialog-footer {
  margin-left: 4.9vw;
  text-align: left;
}

.el-table__header {
}

/deep/ .el-input {
  // width: auto;
}

/deep/ .el-textarea {
  width: 20rem;
}

/deep/ .el-table {
  // height: 98%;
  font-size: 18px;
}

.el-icon-plus {
  font-size: 1.5rem;
  margin-right: 0.5rem;
  cursor: pointer;
}

.el-icon-minus {
  font-size: 1.5rem;
  cursor: pointer;
}

.model-input {
  display: flex;
}

&::-webkit-scrollbar {
  width: 3px;
}

// 滚动条里面默认的小方块,自定义样式
&::-webkit-scrollbar-thumb {
  background: #8798af;
  border-radius: 2px;
}

// 滚动条里面的轨道
&::-webkit-scrollbar-track {
  background: transparent;
}
</style>



// WEBPACK FOOTER //
// src/views/Paper/Theory/index.vue